module.exports = __webpack_public_path__ + "static/media/import_4.53e6d9c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/import_4.jpg
// module id = 1856
// module chunks = 0